import { r as e } from "../../chunks/index.es.wVhS2yfK.js";
import { Node as t, Transforms as n } from "slate";
// lib/Factbox/lib/normalizeFactbox.ts
var r = (r, i) => {
	let [, a] = i, o = Array.from(t.children(r, a));
	if (!e.isOfType(o[0][0], "core/factbox/title")) return n.insertNodes(r, {
		id: crypto.randomUUID(),
		class: "text",
		type: "core/factbox/title",
		children: [{ text: "" }]
	}, { at: [...a, 0] }), !0;
	let s = o.slice(1);
	if (s.findIndex(([t]) => e.isOfType(t, "core/factbox/body")) === -1) {
		let e = s.map(([e]) => e);
		for (let e = o.length - 1; e > 0; e--) n.removeNodes(r, { at: [...a, e] });
		return n.insertNodes(r, {
			id: crypto.randomUUID(),
			class: "block",
			type: "core/factbox/body",
			children: e.length ? e : [{
				id: crypto.randomUUID(),
				type: "core/text",
				class: "text",
				children: [{ text: "" }]
			}]
		}, { at: [...a, 1] }), !0;
	}
};
export { r as normalizeFactbox };
